"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _contentType = require("@insided/shared/utils/contentType");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _Article = _interopRequireDefault(require("@insided/destination/icons/Article"));

var _Question = _interopRequireDefault(require("@insided/destination/icons/Question"));

var _Discussion = _interopRequireDefault(require("@insided/destination/icons/Discussion"));

var _Idea = _interopRequireDefault(require("@insided/destination/icons/Idea"));

var _ProductUpdate = _interopRequireDefault(require("@insided/destination/icons/ProductUpdate"));

var _UserAvatar = _interopRequireDefault(require("@insided/deprecated-preact-components/User/UserAvatar"));

var _AvatarLink = require("@insided/deprecated-preact-components/User/AvatarLink");

var _Skeleton = require("@insided/destination/uikit/Skeleton");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * Renders the appropriate icon based on content type
 * Optimized for tree-shaking with direct conditionals
 */
var TopicIcon = function TopicIcon(_ref) {
  var contentType = _ref.contentType;
  var legacyContentType = (0, _contentType.getLegacyContentType)(contentType);

  switch (legacyContentType) {
    case 'article':
      return (0, _preact.h)(_Article.default, {
        width: 24,
        height: 24
      });

    case 'question':
      return (0, _preact.h)(_Question.default, {
        width: 24,
        height: 24
      });

    case 'discussion':
      return (0, _preact.h)(_Discussion.default, {
        width: 24,
        height: 24
      });

    case 'idea':
      return (0, _preact.h)(_Idea.default, {
        width: 24,
        height: 24
      });

    case 'productUpdate':
      return (0, _preact.h)(_ProductUpdate.default, {
        width: 24,
        height: 24
      });

    default:
      return (0, _preact.h)(_Article.default, {
        width: 24,
        height: 24
      });
    // fallback
  }
};

var CategoryTopicListItem = function CategoryTopicListItem(_ref2) {
  var topic = _ref2.topic;
  var publicId = topic.publicId,
      title = topic.title,
      contentType = topic.contentType,
      author = topic.author,
      featuredImage = topic.featuredImage,
      topicUrl = topic.topicUrl;
  var legacyContentType = (0, _contentType.getLegacyContentType)(contentType);
  var userUrl = (0, _AvatarLink.generateDestinationUserUrl)(author.username, author.id);

  var handleUserClick = function handleUserClick(e) {
    e.preventDefault();
    e.stopPropagation();
    window.location.href = userUrl;
  };

  var handleUserKeyDown = function handleUserKeyDown(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      e.stopPropagation();
      window.location.href = userUrl;
    }
  };

  return (0, _preact.h)("div", {
    className: "category-topic-list-item",
    key: publicId
  }, (0, _preact.h)("div", {
    className: "category-topic-list-item__icon"
  }, (0, _preact.h)(TopicIcon, {
    contentType: contentType
  })), (0, _preact.h)("a", {
    className: "category-topic-list-item__content link",
    href: (0, _absoluteUrlRuntime.resolveUrl)(topicUrl.destination)
  }, (0, _preact.h)("h4", {
    className: "category-topic-list-item__title"
  }, title), (0, _preact.h)("div", {
    className: "category-topic-list-item__metadata"
  }, (0, _preact.h)(_phrase.default, {
    p: "knowledge.base.topic.metadata.".concat(legacyContentType)
  }, function (phrase) {
    return phrase || (0, _preact.h)(_Skeleton.TextSkeleton, {
      width: "4.3em"
    });
  }), (0, _preact.h)(_UserAvatar.default, {
    user: _objectSpread(_objectSpread({}, author), {}, {
      name: author.username
    }),
    extraClass: "avatar--XS",
    disableLink: true
  }), (0, _preact.h)("span", {
    className: "category-topic-list-item__user",
    role: "link",
    tabIndex: 0,
    onClick: handleUserClick,
    onKeyDown: handleUserKeyDown
  }, author.username))), featuredImage && (0, _preact.h)("div", {
    className: "category-topic-list-item__image"
  }, (0, _preact.h)("img", {
    src: (0, _absoluteUrlRuntime.resolveUrl)(featuredImage),
    alt: ""
  })));
};

var _default = CategoryTopicListItem;
exports.default = _default;